function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { HttpClient } from 'api/http-client';
import { NITRO_BREW_AGENT_ROLE } from './types';
export { NITRO_BREW_AGENT_ROLE } from './types';
class NitroBrewHttpClient extends HttpClient {
    constructor(...args){
        super(...args), _define_property(this, "getAgents", ()=>this.get('/agents/autopilot/agents', {
                params: {
                    agent_role: NITRO_BREW_AGENT_ROLE
                }
            }));
    }
}
export const nitroBrewHttpClient = new NitroBrewHttpClient();
